import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cached = null;
let inflight = null;

/** Whether the public calculator is published (admin toggle). Fetched once per page load and shared. */
export const useCalculatorEnabled = () => {
  const [enabled, setEnabled] = useState(cached ?? true);
  useEffect(() => {
    if (cached !== null) { setEnabled(cached); return; }
    inflight = inflight || api.get("/public/calculator").then(({ data }) => (cached = data.enabled !== false)).catch(() => (cached = true));
    inflight.then((v) => setEnabled(v));
  }, []);
  return enabled;
};
